const featurePrefix = '[LIF][ReferFriend]'

export const LOG_ERROR_MESSAGE = {
  FETCH_REFERRAL: `${featurePrefix}[API] Failed to fetch referral data`,
  GENERATE_PROMO_CODE: `${featurePrefix}[Generate] Failed to generate promo code`,
  COPY_TO_CLIPBOARD: `${featurePrefix}[Clipboard] Failed to copy to clipboard`,
  SHARE_CODE: `${featurePrefix}[Share] Web Share API failed`,
}
